module.exports = __webpack_public_path__ + "img/cpt-fp-en.655f2c8b.png";